import React from 'react'
import { AREA_FLAGS } from '../../app/constants/flags'
import { getLang } from '../../app/selectors/lang'
import SedaFlagGroup from './SedaFlagGroup'

const SedaAreaClassification = ({ region, ...props }) => {
  // area classification flags
  const flags = AREA_FLAGS
  // unavailable for non-district and non-schools
  const isDisabled =
    region !== 'districts' && region !== 'schools'
  // text when disabled: These filters are only available in {{regions}} view.
  const tooltipText =
    isDisabled &&
    getLang('TOOLTIP_HINT_REGION_FILTER', {
      regions: 'districts and schools'
    })

  return (
    <SedaFlagGroup
      tooltip={tooltipText}
      disabled={isDisabled}
      flags={flags}
      {...props}
    />
  )
}

export default SedaAreaClassification
